import { CookieHelper } from "../../Common/CookieHelper";
import { GlobalData } from "../../Common/GlobalData";
import { Notification } from "../../Common/KendoHelpers";

export class ImportFiles {
    // Make these static so they can be accessed in the event handlers.
    private static readonly ISSUE_NO = '#issueNo';
    private static readonly DATE_OF_ISSUE = '#dateOfIssue';
    private static readonly DATE_OF_PRICE = '#dateOfPrice';
    private static readonly VL_FILES_UPLOAD = '#vlFilesUpload';
    private static readonly SPINNER = '#spinner';
    private static errorMessage: string;

    private issueNo!: kendo.ui.NumericTextBox;
    private dateOfIssue!: kendo.ui.DatePicker;
    private dateOfPrice!: kendo.ui.DatePicker;

    private static _instance: ImportFiles;
    public static getInstance() {
        return this._instance || (this._instance = new this());
    }

    private constructor() {
        this.init();
    }

    private init() {
        let issueNo: number = CookieHelper.get(GlobalData.VL_ISSUE_NO_COOKIE);
        if (!issueNo) {
            issueNo = 1;
            CookieHelper.set(GlobalData.VL_ISSUE_NO_COOKIE, issueNo);
        }

        this.issueNo = $(ImportFiles.ISSUE_NO).kendoNumericTextBox({
            value: issueNo,
            format: '0',
            decimals: 0,
            min: 1,
            max: 13,
            change: this.onIssueNoChange,
        }).data('kendoNumericTextBox')!;

        let dateOfIssue: string = CookieHelper.get(GlobalData.VL_DATE_OF_ISSUE_COOKIE);
        if (!dateOfIssue) {
            dateOfIssue = new Date().toLocaleDateString();
            CookieHelper.set(GlobalData.VL_DATE_OF_ISSUE_COOKIE, dateOfIssue);
        }

        this.dateOfIssue = $(ImportFiles.DATE_OF_ISSUE).kendoDatePicker({
            dateInput: true,
            value: new Date(dateOfIssue),
            change: this.onDateOfIssueChange,
        }).data('kendoDatePicker')!;

        let dateOfPrice: string = CookieHelper.get(GlobalData.VL_DATE_OF_PRICE_COOKIE);
        if (!dateOfPrice) {
            dateOfPrice = new Date().toLocaleDateString();
            CookieHelper.set(GlobalData.VL_DATE_OF_PRICE_COOKIE, dateOfPrice);
        }

        this.dateOfPrice = $(ImportFiles.DATE_OF_PRICE).kendoDatePicker({
            dateInput: true,
            value: new Date(dateOfPrice),
            change: this.onDateOfPriceChange,
        }).data('kendoDatePicker')!;

        $(ImportFiles.VL_FILES_UPLOAD).kendoUpload({
            async: {
                saveUrl: GlobalData.URL_BASE +
                    GlobalData.URL_SUFFIX_IMPORT_DATA + '/save',
            },
            upload: (e: any) => {
                this.onUpload(e);
            },
            error: (e: any) => {
                this.onError(e);
            },
            complete: () => {
                this.onComplete();
            },
        }).data('kendoUpload');
    }

    private onIssueNoChange() {
        const self = ImportFiles.getInstance();
        const value = self.issueNo.value();
        CookieHelper.set(GlobalData.VL_ISSUE_NO_COOKIE, value);
    }

    private onDateOfIssueChange() {
        const self = ImportFiles.getInstance();
        const value = self.dateOfIssue.value();
        const valueStr = kendo.toString(value, 'MM/dd/yyyy');
        CookieHelper.set(GlobalData.VL_DATE_OF_ISSUE_COOKIE, valueStr);
    }

    private onDateOfPriceChange() {
        const self = ImportFiles.getInstance();
        const value = self.dateOfPrice.value();
        const valueStr = kendo.toString(value, 'MM/dd/yyyy');
        CookieHelper.set(GlobalData.VL_DATE_OF_PRICE_COOKIE, valueStr);
    }

    private onUpload(e: any) {
        $(ImportFiles.SPINNER).show();
        ImportFiles.errorMessage = '';
    }

    private onError(e: any) {
        if (e && e.XMLHttpRequest && e.files && e.files.length) {
            const status = e.XMLHttpRequest.status;
            const fileName = e.files[0].name;

            switch (status) {
                case 400:
                    ImportFiles.errorMessage += '<br>Exception thrown: ' + e.XMLHttpRequest.responseText;
                    break;
                case 401:
                    ImportFiles.errorMessage = '<br>Unauthorized';
                    break;
                case 404:
                    ImportFiles.errorMessage += '<br>Unsupported file ' + fileName;
                    break;
                default:
                    ImportFiles.errorMessage += '<br>Error code ' + status +
                        ' returned for file ' + fileName;
            }
        }
    }

    private onComplete() {
        $(ImportFiles.SPINNER).hide();
        var notification = new Notification(Notification.reloadPage);

        if (ImportFiles.errorMessage.length == 0) {
            notification.success('File imported successfully');
        } else {
            notification.error(ImportFiles.errorMessage);
        }
    }
}

